<template>
    <div class="row">
        <div class="col">
            <div class="d-flex align-items-end mb-3">
                <h4 class="mb-0">
                    {{ $tc('models.contract') }}:
                </h4>
                <span class="text-muted ml-1">{{ model.name }}</span>
            </div>

            <div>
                <div
                    v-for="(d, index) in contractData"
                    :key="index"
                    class="flex-row"
                >
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $t(d.title) }}:
                        </span>

                        <currency
                            v-if="d.isCurrency"
                            v-model="d.value"
                        />
                        <span v-else>
                            {{ d.value }}
                        </span>
                    </div>
                </div>
            </div>

            <template
                v-if="model.period === 'none' && store.getters.hasPermission('contracts.buy')"
            >
                <hr>
                <h4 class="mt-4 mb-2">
                    {{ $t('prepaidcard.upgrade') }}
                </h4>
                <div class="row">
                    <div class="col-9">
                        <BFormGroup
                            horizontal
                            :label="$t('prepaidcard.add-hours')"
                            :label-cols="4"
                            breakpoint="md"
                        >
                            <prepaid-card-select v-model="prepaidCardType" />
                        </BFormGroup>
                    </div>
                    <div class="col-2">
                        <loading-button
                            class="btn mb-3 btn-primary"
                            :disabled="!prepaidCardType"
                            :loading="loading"
                            @click="buyPrepaidCard"
                        >
                            {{ $t('prepaidcard.upgrade') }}
                        </loading-button>
                    </div>
                </div>
            </template>

            <div
                v-for="(contractPeriod, index) in model.contract_periods"
                :key="index"
            >
                <hr>
                <h4 class="mt-4 mb-0">
                    {{ $t('contractperiod.period') }}
                    {{ $dayjs(contractPeriod.period_start).format('DD-MM-YYYY') }} -
                    <template v-if="contractPeriod.period_end">
                        {{ $dayjs(contractPeriod.period_end).format('DD-MM-YYYY') }}
                    </template>
                </h4>

                <span class="mb-2">
                    {{
                        $t('contractperiod.registered-time')
                    }}: {{ $filters.minutesToTime(contractPeriod.registered_time) }}
                </span>

                <br>
                <span class="mb-2">
                    {{ $t('contractperiod.remaining-time') }}: {{
                        $filters.minutesToTime(contractPeriod.minutes_remaining)
                    }}
                </span>

                <table class="table table-sm table-actions mt-3">
                    <thead>
                        <tr>
                            <th style="width:25%">
                                {{ $tc('models.ticket') }}
                            </th>
                            <th style="width:20%">
                                {{ $tc('timeregistration.description') }}
                            </th>
                            <th style="width:10%">
                                {{ $tc('timeregistration.time') }}
                            </th>
                            <th style="width:15%">
                                {{ $tc('timeregistration.date') }}
                            </th>
                            <th style="width:15%">
                                {{ $tc('models.activity') }}
                            </th>
                            <th style="width:15%">
                                {{ $tc('models.operator') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="tr in contractPeriod.time_registrations"
                            :key="tr.id"
                        >
                            <td>
                                <router-link
                                    v-if="tr.ticket_id"
                                    :to="`/tickets/${tr.ticket_id}`"
                                >
                                    {{ tr.ticket_reference }} - {{ tr.ticket_description }}
                                </router-link>
                            </td>
                            <td>
                                {{ tr.description }}
                            </td>
                            <td>
                                {{ $filters.minutesToTime(tr.time_spent_rounded) }}
                            </td>
                            <td>
                                {{ $dayjs(tr.executed_at).format('DD-MM-YYYY HH:mm') }}
                            </td>
                            <td>
                                {{ tr.activity ? tr.activity.name : `(${$t('defaults.none')})` }}
                            </td>
                            <td class="text-left">
                                {{ tr.operator ? tr.operator.full_name : `(${$t('defaults.none')})` }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Show from '@/mixins/Show';
import store from '@/store';
import { toast } from 'vue3-toastify';

export default {
    mixins: [Show],
    data () {
        return {
            loading: false,
            prepaidCardType: undefined,
        };
    },
    computed: {
        periodLabel () {
            return this.$t(`period.${this.model.period}`);
        },
        contractData () {
            return [
                {
                    title: 'contract.period',
                    value: this.periodLabel,
                },
                {
                    title: 'contract.hours',
                    value: this.model.quantity,
                },
                {
                    title: 'contract.remaining-hours',
                    value: this.$filters.minutesToTime(this.model.minutes_remaining),
                },
                {
                    title: 'contract.start-date',
                    value: this.$dayjs(this.model.start_date).format('DD MMM YY'),
                },
                {
                    title: 'contract.end-date',
                    value: this.model.end_date ? this.$dayjs(this.model.end_date).format('DD MMM YY') : `(${this.$t('defaults.none')})`,
                },
            ];
        },
        store () {
            return store;
        },
    },
    methods: {
        buyPrepaidCard () {
            this.loading = true;

            this.model.buy(this.prepaidCardType).then(() => {
                toast(this.$t('prepaidcard.upgrade-success'), {
                    type: toast.TYPE.SUCCESS,
                });
                this.prepaidCardType = undefined;
                this.load();
            }).catch(() => {
                toast(this.$t('prepaidcard.upgrade-failure'), {
                    type: toast.TYPE.ERROR,
                });
            }).finally(() => {
                this.loading = false;
            });
        },
    },
};
</script>
